import { ReactElement, useState } from 'react';
import QRCode from 'react-qr-code';
import { Modal, notification, Spin } from 'antd';

import { useAuth } from '../../providers/Auth';
import { DriverLoginTokenResponse, getDriverLoginQRCode } from '../../services/driverServices/getLoginQRCode';

import './login-driver-qr-code.css';

export function LoginDriverQRCode({ userId }: { userId: number }): ReactElement {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [token, setToken] = useState<DriverLoginTokenResponse | null>(null);
  const { dashboardSdk } = useAuth();

  const getToken = async () => {
    setShowModal(true);
    setIsLoading(true);

    try {
      setToken(await getDriverLoginQRCode(dashboardSdk, userId));
    } catch (ex) {
      notification.error({
        placement: 'bottomRight',
        message: (ex as Error).message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-driver-qr-code-wrapper">
      <a onClick={() => getToken()}>Login by QR Code</a>

      <Modal
        wrapClassName="qr-code-modal"
        maskClosable={true}
        visible={showModal}
        width="fit-content"
        footer={null}
        centered={true}
        onCancel={() => setShowModal(false)}
      >
        {isLoading ? (
          <Spin className="login-driver-loader" />
        ) : (
          <QRCode
            className="login-driver-qr-code"
            value={JSON.stringify({
              token: token?.access_token,
              secret: token?.secret,
              region: token?.region,
            })}
          />
        )}
      </Modal>
    </div>
  );
}
